

<template>
<div class="upDateCarInfoDialog">
  <el-dialog title="编辑车辆"
             :visible.sync="visible"
             @close="closeCarDriverDialog()"
             width="60%"
             :close-on-click-modal="false">

    <el-form label-width="120px">
      <el-form-item label="车牌">
        <el-input placeholder="请输入车牌号" v-model="requestAddCarInfo.carNum"></el-input>
      </el-form-item>

      <el-form-item label="车辆标识">
        <el-input placeholder="请输入车辆标识（设备IMEI号）" v-model="requestAddCarInfo.carNo"></el-input>
      </el-form-item>

      <el-form-item label="车辆类型">

        <el-select v-model="carTypeItem"
                   value-key="dictValue"
                   placeholder="请选择设车辆类型" style="width: 100%">
          <el-option
              v-for="item in this.carTypeList"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item">
          </el-option>
        </el-select>

      </el-form-item>

      <el-form-item label="行驶证">
          <div>
            <input type="file" ref="fileInput" @change="onFileChange" style="display: none"
              accept="image/jpeg,image/png" />
            <el-button @click="addPhoto()">点击上传</el-button>
            <div v-if="showPhoto" style="margin-top: 10px;">
              <img :src="showPhoto" alt="" style="width: 100px;height: 100px;">
            </div>

          </div>

        </el-form-item>

      <el-form-item label="所属部门">
        <div style="display:flex;flex-direction: row;border: 1px solid #DCDFE6;border-radius: 4px;padding-left: 15px;
          justify-content: space-between">


          <!--       //因为是编辑 默认会带过来 部门id    -->
          <div v-if="this.selectDepartment!=null">
            {{ this.selectDepartment.data.name }}
          </div>
          <div v-else>
            {{ this.selectDepartmentTxtName }}
          </div>

          <el-button  @click="addDepartmentDialogVisible = true"
                      style="border-left: 1px solid #DCDFE6;border-top:0;border-bottom: 0;border-right: 0;background: #f5f7fa"
          >选择部门</el-button>

        </div>

      </el-form-item>

      <el-form-item label="">
        <el-checkbox v-model="cameraMarkChecked">车辆定位仪</el-checkbox>
        <el-input v-model="cameraNoTxt"
                  v-if="cameraMarkChecked"
                  placeholder="请输入定位仪编号"/>
      </el-form-item>


      <el-form-item label="">
        <el-checkbox v-model="carMarkChecked">固定班组</el-checkbox>


        <el-select v-model="groupItem"
                   value-key="id"
                   placeholder="请选择固定班组" style="width: 100%"
                   v-if="carMarkChecked">
          <el-option
              v-for="item in this.groupInfoList"
              :key="item.id"
              :label="item.name"
              :value="item">
          </el-option>


        </el-select>


      </el-form-item>


      <el-form-item label="司机">
        <div style="display:flex;flex-direction: row;border: 1px solid #DCDFE6;border-radius: 4px;padding-left: 15px;
          justify-content: space-between">



          <div v-if="this.selectCarDeiverList.length>0" style="margin-left: 10px">
            {{ this.selectCarDeiverList[0].name }}
          </div>
          <div v-else>
            {{ this.selectCarDeiverItemName  }}
          </div>
          <el-button @click="openAddCarDriver()"
                     style="border-left: 1px solid #DCDFE6;
                     border-top:0;border-bottom: 0;border-right: 0;background: #f5f7fa">
            选择司机</el-button>



        </div>

      </el-form-item>


    </el-form>

    <div style=" display: flex; flex-direction: row; align-items: center;justify-content: center">
      <el-button type="primary" @click="updateCarInfoSubmit()">确 定</el-button>

      <el-button  @click="updateCarInfoDialogClose()">取 消</el-button>
    </div>
  </el-dialog>


  <!--  司机 -->
  <add-people
      :addPeopleVisible="addCarDriverDialogVisible"
      dialogTitle="选择司机"
      :peopleList="selectCarDeiverList"
      :isLimit="true"
      @closeAddPeopleVisible="closeCarDriverDialog"
      @submitPeople="submitCarDriver"
  />

  <!-- 选择部门 department -->

  <el-dialog
      :visible.sync="addDepartmentDialogVisible"
      title="选择部门"
  >
    <div style="display: flex; flex-direction: column">
      <div style="display:flex;flex-direction: column;justify-content: center">
        <el-tree
            :data="organizatonData"
            @node-click="organizationClick"
            :props="defaultProps"
            node-key="id"
            default-expand-all
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            highlight-current
            ref="tree"
        >
        </el-tree>
      </div>

      <div style=" display: flex; flex-direction: row; align-items: center;justify-content: center">
        <el-button type="primary" @click="addDepartmentSubmit()">确 定</el-button>

        <el-button @click="addDepartmentDialogVisible=false">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</div>

</template>

<style scoped lang="scss">

</style>

<script>
import AddPeople from "@/components/AddPeople/index.vue";
import {carAdd, carUpdate} from "@/api/equipmentmanagement";
import CommonFile from "@/api/common";
export default {
  name: "UpDateCarInfoDialog",
  components: {AddPeople},
  props: {
    updateCarInfoDialogVisible: false,

    //传入的车辆信息
    selectCarUpdateInfo:{},

    carTypeList:[],
    groupInfoList:[],
    organizatonData:[],

    showPhoto:'',
  },
  watch: {
    updateCarInfoDialogVisible(val) {
      if (val) {
        //显示数据

        this.requestAddCarInfo.id =  this.selectCarUpdateInfo.carId
        
        this.showPhoto =  this.selectCarUpdateInfo.photoUrl

        this.requestAddCarInfo.carNum = this.selectCarUpdateInfo.carNum
        this.requestAddCarInfo.carNo = this.selectCarUpdateInfo.carNo

        this.carTypeList.forEach((value,index)=>{

          if(value.dictValue === this.selectCarUpdateInfo.carType.toString()){
            this.carTypeItem = value
          }
        })

        this.selectDepartmentTxtID = this.selectCarUpdateInfo.deptId
        this.selectDepartmentTxtName = this.selectCarUpdateInfo.deptName


        if(this.selectCarUpdateInfo.cameraNo!=null){
          //定位仪编号
          this.cameraMarkChecked = true
          this.cameraNoTxt = this.selectCarUpdateInfo.cameraNo
        }

        if(this.selectCarUpdateInfo.groupId!==0){
          //固定班组
          this.carMarkChecked = true
          this.groupInfoList.forEach((value,index)=>{
            if(value.id === this.selectCarUpdateInfo.groupId){
              this.groupItem  = value
            }
          })
        }

        this.selectCarDeiverItemID = this.selectCarUpdateInfo.driverId
        this.selectCarDeiverItemName = this.selectCarUpdateInfo.driverName

      }
    },
  },
  computed: {
    visible: {
      get() {
        return this.updateCarInfoDialogVisible;
      },
      set(val) {
        if (!val) {
          this.$emit("closeEvent");
        }
      },
    },
  },
  data(){
    return{
      defaultProps: {
        children: "childDeptDto",
        label: "name",
        id: "id",
        parentId: "parentId",
      },

      addCarDriverDialogVisible: false,

      //选择部门
      addDepartmentDialogVisible: false,


      //因为是编辑 默认会带过来 部门id
      selectDepartmentTemp: null,
      selectDepartment: null,
      selectDepartmentTxtID:'',
      selectDepartmentTxtName:'',


      cameraMarkChecked: false,
      carTypeItem: null,

      carMarkChecked: false,
      groupItem: null,

      cameraNoTxt: '',

      selectCarDeiverList: [],
      selectCarDeiverItemID:'',
      selectCarDeiverItemName:'',


      requestAddCarInfo: {

        carNo: "",        //车辆标识（设备IMEI号）
        carNum: "",       //车牌

        carType:  "",                           //	车辆类型，详见枚举表car_type
        carTypeName:  "",                        //	车辆类型名称

        deptId:  0,                    //部门ID
        deptName:  "",           //部门名称

        driverId:  0,         //	司机ID
        driverName:  "",     //司机姓名

        cameraMark:0,    //有无记录仪标识，0：无 1：有
        cameraNo: 0,             //记录仪编号

        carMark:  1,     //车辆固定标识，0：固定车辆 1：流动车辆   默认流动车辆1
        groupId:  0,        //班组ID
        groupName: "",    //班组name
        photoUrl:""
      }

    }
  },
  methods:{
    addPhoto() {
      this.$refs.fileInput.click();
    },
    //上传文件
    async onFileChange(event) {
      const selectedFiles = Array.from(event.target.files);
      CommonFile.commonUploadFile("zngy", selectedFiles[0]).then((res) => {
        if (res.data.code == 200) {
          this.requestAddCarInfo.photoUrl = res.data.data.filePath;
          this.showPhoto = res.data.data.fileUrl;
        } else {
          this.$message.error(res.data.message);
        }
      }).finally(() => {
        event.target.value = ""
      });
    },
    updateCarInfoSubmit() {

      if (this.requestAddCarInfo.carNum === "") {
        this.$message.error('请输入车牌号');
        return
      }

      if (this.requestAddCarInfo.carNo === "") {
        this.$message.error('请输入车辆标识（设备IMEI号）');
        return
      }

      if (this.carTypeItem === null) {
        this.$message.error('请选择车辆类型');
        return
      } else {
        this.requestAddCarInfo.carType =   parseInt(this.carTypeItem.dictValue)                   //	车辆类型，详见枚举表car_type
        this.requestAddCarInfo.carTypeName = this.carTypeItem.dictName                     //	车辆类型名称
      }

      if (!this.requestAddCarInfo.photoUrl) {
        this.$message.error('请上传行驶证照片');
        return
      }
      if (this.selectDepartment === null) {
        //使用传来的值
        this.requestAddCarInfo.deptId = this.selectDepartmentTxtID                   //部门ID
        this.requestAddCarInfo.deptName = this.selectDepartmentTxtName           //部门名称
      }else{
        this.requestAddCarInfo.deptId = this.selectDepartment.data.id                    //部门ID
        this.requestAddCarInfo.deptName = this.selectDepartment.data.name            //部门名称
      }

      if (this.cameraMarkChecked) {
        if(this.cameraNoTxt === ""){
          this.$message.error('请输入车辆定位仪编号');
          return
        }else{
          this.requestAddCarInfo.cameraNo = this.cameraNoTxt
          this.requestAddCarInfo.cameraMark = 1   //有无记录仪标识，0：无 1：有
        }
      }


      if (this.carMarkChecked) {
        if(this.groupItem === null){
          this.$message.error('请选择固定班组');
          return
        }else{
          this.requestAddCarInfo.carMark =  0    //车辆固定标识，0：固定车辆 1：流动车辆   选择了固定班组是1流通车辆
          this.requestAddCarInfo.groupId =  this.groupItem.id        //班组ID
          this.requestAddCarInfo.groupName =  this.groupItem.name//班组name
        }
      }

      if (this.selectCarDeiverList.length <= 0) {
        //使用传来的值
        this.requestAddCarInfo.driverId = this.selectCarDeiverItemID         //	司机ID
        this.requestAddCarInfo.driverName = this.selectCarDeiverItemName      //司机姓名
      }else{
        this.requestAddCarInfo.driverId = this.selectCarDeiverList[0].id         //	司机ID
        this.requestAddCarInfo.driverName = this.selectCarDeiverList[0].name      //司机姓名
      }

      carUpdate(this.requestAddCarInfo).then((res) => {
        if (res.data.code === 200) {
          this.$message({message: '修改成功', type: 'success'});

          this.$emit("afterSubmitEvent");
          this.updateCarInfoDialogClose()
        }else{
          this.$message.error(res.data.message);
        }
      });
    },
    updateCarInfoDialogClose(){
      this.visible = false
    },

    closeCarDriverDialog() {
      this.addCarDriverDialogVisible = false
    },
    submitCarDriver(employeeRoleList) {
      this.selectCarDeiverList = employeeRoleList
    },
    addDepartmentSubmit() {
      //确认 选择某个部门
      this.selectDepartment = this.selectDepartmentTemp
      this.addDepartmentDialogVisible = false
    },
    //选择部门
    organizationClick(data, node) {
      this.selectDepartmentTemp = node
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    openAddCarDriver() {
      this.addCarDriverDialogVisible = true
    },
  },
  created() {

  }
}
</script>